import React, { Fragment } from 'react';
import classNames from 'classnames';
import styles from '../styles.module.scss';

export const SubmitActionsDisplayComponent = ({ syncWithSalesForceInfo, submissionInfo }) => {
  const displayText = ({ sync_date, sync_by, type }) => {
    const formattedDate = sync_date && new Date(Date.parse(sync_date)).toLocaleString();
    return `Last ${type} happened: ${!!formattedDate ? `${formattedDate} by ${sync_by}` : '- - -'}`;
  };

  return (
    <Fragment>
      <div className={classNames('flex mb-3', styles.infoContainer)}>
        <div className={classNames('flex', styles.infoIcon)}>i</div>
        <div className="block">
          {syncWithSalesForceInfo && (
            <div className="mb-1 font-medium italic">{displayText({ ...syncWithSalesForceInfo, type: 'sync' })}</div>
          )}
          {submissionInfo && (
            <div className="font-medium italic">{displayText({ ...submissionInfo, type: 'submit' })}</div>
          )}
        </div>
      </div>
    </Fragment>
  );
};
